<template>
  <div :style="pageStyle" v-resize="handleResize">
    <div class="menu-list" v-if="menuList">
      <el-table
        ref="table"
        :data="menuList"
        :show-header="false"
        :cell-class-name="activeClass"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        @current-change="handleClick"
        row-key="value"
      >
        <el-table-column prop="label" align="center" min-width="120">
          <template slot-scope="scope">
            <span style="color: #000000">
              {{ scope.row.label }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<style lang="less" scoped>
.menu-list {
  overflow: auto;
  max-height: var(--menu-height);
  border: 2px solid #f1f1f1;
}

// 隐藏滚动条
.menu-list::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>

<style lang="less" >
.active-class {
  background: #f1f1f1;
}
</style>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
    menuList: {
      type: Array,
      default: () => {
        return []
      }
    },
    offsetSize: {
      type: Number,
      default: 180
    },
    loading: {
      type: Boolean,
      default: false
    },
    value: {
      type: String
    }
  },
  computed: {
    pageParams() {
      return Object.assign({},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign({},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
    pageStyle() {
      return {
        "min-height": "100px",
        "--menu-height": `${this.boxHeight}px`,
      }
    }
  },
  model: {
    prop: "value",
    event: "change"
  },
  data() {
    return {
      boxHeight: 300,
    };
  },
  methods: {
    activeClass({ row, column, rowIndex, columnIndex }) {
      if (row.value == this.value) return "active-class";
    },
    handleResize() {
      let height =
        document.documentElement.clientHeight || document.body.clientHeight;
      this.boxHeight = height - this.offsetSize;
    },
    handleClick(currentRow) {
      this.$emit("change", currentRow && currentRow.value || '');
    },
  },
  mounted() {
    this.handleResize();
  },
};
</script>